export namespace SseFormatter {
  const HEARTBEAT = "<HEARTBEAT/>\n\n";
  const PORTFOLIO_TAG = "<PORTFOLIO>";
  const SYNC_DONE = "<SYNC_DONE/>";

  export function heartbeat(): string {
    return encode(HEARTBEAT);
  }

  export function syncDone(): string {
    return SYNC_DONE;
  }

  export function encodePortfolioId(portfolioId: string) {
    return encode(`${PORTFOLIO_TAG}${portfolioId}${PORTFOLIO_TAG}`);
  }

  export function tryDecodePortfolioId(message: string): string | null {
    const match = message.match(
      new RegExp(`${PORTFOLIO_TAG}(.*)${PORTFOLIO_TAG}`),
    );
    return match ? match[1] : null;
  }

  export function isSyncDone(message: string): boolean {
    return message === SYNC_DONE;
  }

  export function encode(message: string) {
    return `data: ${message}\n\n` as const;
  }

  export function decode(message: string): string {
    return message
      .trim()
      .replace(/^data: /, "")
      .replace(HEARTBEAT.trim(), "")
      .trim();
  }
}
